import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpErrorResponse} from '@angular/common/http';
import {httpOptions} from '../../../configurations/configuration';
import { environment } from '../../../../environments/environment';
import { Observable } from 'rxjs/Observable';

@Injectable({
  providedIn: 'root'
})
export class DeleteVenueService {
  deleteVenueURL: string;
  constructor(private http: HttpClient) {
    this.deleteVenueURL = environment.baseURI + environment.apiUrl + 'venue/update';
  }

  deleteVenue(obj) {
    return this.http.post(this.deleteVenueURL, obj);
  }
}
